import { useAuthenticator } from "@aws-amplify/ui-react";
import { redirectPage } from "@nanostores/router";
import { ReactElement, useEffect } from "react";

import { LoadingIndicator } from "../components/LoadingIndicator.tsx";
import { checkIfAuthError } from "../services/auth/check-if-auth-error.ts";
import { $router } from "../stores/router.ts";

export const AuthCallback = (): ReactElement => {
  const { authStatus, signOut } = useAuthenticator((context) => [
    context.authStatus,
    context.signOut,
  ]);

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      redirectPage($router, "signIn");
    }

    if (authStatus === "authenticated" && !checkIfAuthError(signOut)) {
      redirectPage($router, "dashboard");
    }
  }, [authStatus]);

  return <LoadingIndicator />;
};
